module.exports = __webpack_public_path__ + "img/intro-1.30e79155.jpg";